export default "__VITE_ASSET__CfBYBhAK__"